import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getGroupedByDateTotals } from 'redux/modules/shipper-orders/selectors';

import ShipperOrderTableGroupTitle from './component';

const enhance = compose(
  connect((state, ownProps) => {
    const totals = getGroupedByDateTotals(state);
    return {
      number: totals[ownProps.value],
    };
  }),
  injectIntl
);

export default enhance(ShipperOrderTableGroupTitle);
